import script from "./CustomResourceApplyZG.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyZG.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyZG.vue?vue&type=style&index=0&id=7f6aa282&lang=less&scope=true"

const __exports__ = script;

export default __exports__